import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {throwError} from 'rxjs';
import {JwtService} from 'mclane-webauth-lib';

@Injectable()
export class RoleGuardService  {
    constructor(private _keycloakService: KeycloakService, public router: Router, private _jwtService: JwtService) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        try {
            const expectedRole = route.data.expectedRole;
            if (this._jwtService.roles === undefined) {
                this.router.navigate(['/access_denied']).then(() => {
                });
                return false;
            } else if (!this._jwtService.roles.includes(expectedRole)) {
                this.router.navigate(['/access_denied']).then(() => {
                });
                return false;
            } else {
                return true;
            }
        } catch (e) {
            throwError(e);
        }
    }
}
